import TextSource from './TextSource.js';
import { pokeMartData } from '../data/pokeMartData.js';
export default class MartLocation extends TextSource {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            ...super.serialize(),
            identifier: this.identifier,
            position: this.position,
            preInteractionText: this.preInteractionText,
            postInteractionText: this.postInteractionText,
            inventory: this.inventory,
            clerkDirection: this.clerkDirection,
            // clerk reference will be rebuilt from map's NPCs
        };
    }

    static deserialize(data) {
        return new MartLocation({
            identifier: data.identifier,
            position: data.position,
            // Constructor will load mart data from pokeMartData
        });
    }

    constructor({ text, identifier, position, OSM, GUI }) {
        super({ text, position, OSM, GUI });
        const martSourceData = pokeMartData[identifier];
        this.preInteractionText = martSourceData.preInteractionText;
        this.postInteractionText = martSourceData.postInteractionText;
        this.inventory = martSourceData.inventory;
        this.clerk = null;
        this.clerkDirection = 'right';
        this.identifier = identifier;
    }

    draw() {
        if (this.clerk === null && this.OSM.currentMap !== undefined) {
            const availableClerks = this.OSM.currentMap.npcs.filter((npc) => {
                return npc.type === 'clerk';
            });
            if (availableClerks.length !== 1) {
                console.warn(`Incorrect number of clerks in mart: ${availableClerks.length}`);
            } else {
                this.clerk = availableClerks[0];
                // Note: this is a bit of a simplification that should be revisited
                //       for MartLocations that are not in a pokemart.
                if (this.clerk.position.x === this.position.x - 16) {
                    this.clerkDirection = 'right';
                } else {
                    this.clerkDirection = 'down';
                }
            }
        }
        // c.fillStyle = 'rgba(0, 255, 255, 1)';
        // c.fillRect(
        //     this.position.x + this.xModifier,
        //     this.position.y + this.yModifier,
        //     this.width,
        //     this.height
        // );
    }
}
